var React = require('react');

function Ring (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64 208c0-44.18 86-80 192-80s192 35.82 192 80c0 21.81-20.95 41.57-54.9 56-34.85-14.81-83.39-24-137.1-24s-102.25 9.19-137.1 24C85 249.57 64 229.81 64 208z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 224c-106 0-192-35.82-192-80s86-80 192-80 192 35.82 192 80-86 80-192 80z","className":"fa-primary","key":2})]);
}

Ring.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Ring;

Ring.default = Ring;
